import { Query, QueryOrderDirection, Subject, Visit, Site, VisitScheduleItem } from "../misc/api/apiTypes";
import * as CoreActions from "./CoreActions";
import { Study } from "webportalclient";

export interface CoreState {
    currentStudy: Study;
}

export const initialCoreState: CoreState = {
    currentStudy: null,
}

export function coreReducer(state: CoreState = initialCoreState, action: CoreActions.CoreAction): CoreState {
    switch (action.type) {
        case CoreActions.CoreActionType.LoadCurrentStudy:
            return {
                ...state,
                currentStudy: action.study,
            };
        default:
            return state;
    }
}
